// Coduri CAEN Rev.2 — lista relevantă pentru clienți DDD (peste 200 coduri)
// Include: agricultură, alimentație, HoReCa, sănătate, retail, industrie alimentară, depozitare,
// educație, birouri, transport, servicii, industrie generală.

export const CAEN_CODES = [
  // A. Agricultură, silvicultură, pescuit
  { cod: "0111", denumire: "Cultivarea cerealelor (exclusiv orez), plantelor leguminoase și a plantelor producătoare de semințe oleaginoase" },
  { cod: "0113", denumire: "Cultivarea legumelor și a pepenilor, a rădăcinoaselor și tuberculilor" },
  { cod: "0121", denumire: "Cultivarea strugurilor" },
  { cod: "0124", denumire: "Cultivarea fructelor semințoase și sâmburoase" },
  { cod: "0141", denumire: "Creșterea bovinelor de lapte" },
  { cod: "0142", denumire: "Creșterea altor bovine" },
  { cod: "0145", denumire: "Creșterea ovinelor și caprinelor" },
  { cod: "0146", denumire: "Creșterea porcinelor" },
  { cod: "0147", denumire: "Creșterea păsărilor" },
  { cod: "0149", denumire: "Creșterea altor animale" },
  { cod: "0150", denumire: "Activități în ferme mixte (cultura vegetală combinată cu creșterea animalelor)" },
  { cod: "0161", denumire: "Activități auxiliare pentru producția vegetală" },
  { cod: "0162", denumire: "Activități auxiliare pentru creșterea animalelor" },
  { cod: "0210", denumire: "Silvicultură și alte activități forestiere" },
  { cod: "0311", denumire: "Pescuitul maritim" },
  { cod: "0321", denumire: "Acvacultura maritimă" },

  // C. Industria prelucrătoare — alimente
  { cod: "1011", denumire: "Prelucrarea și conservarea cărnii" },
  { cod: "1012", denumire: "Prelucrarea și conservarea cărnii de pasăre" },
  { cod: "1013", denumire: "Fabricarea produselor din carne (inclusiv din carne de pasăre)" },
  { cod: "1020", denumire: "Prelucrarea și conservarea peștelui, crustaceelor și moluștelor" },
  { cod: "1031", denumire: "Prelucrarea și conservarea cartofilor" },
  { cod: "1032", denumire: "Fabricarea sucurilor de fructe și legume" },
  { cod: "1039", denumire: "Prelucrarea și conservarea fructelor și legumelor n.c.a." },
  { cod: "1041", denumire: "Fabricarea uleiurilor și grăsimilor" },
  { cod: "1051", denumire: "Fabricarea produselor lactate și a brânzeturilor" },
  { cod: "1052", denumire: "Fabricarea înghețatei" },
  { cod: "1061", denumire: "Fabricarea produselor de morărit" },
  { cod: "1071", denumire: "Fabricarea pâinii; fabricarea prăjiturilor și a produselor proaspete de patiserie" },
  { cod: "1072", denumire: "Fabricarea biscuiților și pișcoturilor; fabricarea prăjiturilor și a produselor conservate de patiserie" },
  { cod: "1073", denumire: "Fabricarea macaroanelor, tăițeilor, cuș-cuș-ului și a altor produse făinoase similare" },
  { cod: "1081", denumire: "Fabricarea zahărului" },
  { cod: "1082", denumire: "Fabricarea produselor din cacao, a ciocolatei și a produselor zaharoase" },
  { cod: "1083", denumire: "Prelucrarea ceaiului și cafelei" },
  { cod: "1085", denumire: "Fabricarea de mâncăruri preparate" },
  { cod: "1086", denumire: "Fabricarea preparatelor alimentare omogenizate și alimentelor dietetice" },
  { cod: "1089", denumire: "Fabricarea altor produse alimentare n.c.a." },
  { cod: "1091", denumire: "Fabricarea preparatelor pentru hrana animalelor de fermă" },
  { cod: "1092", denumire: "Fabricarea preparatelor pentru hrana animalelor de companie" },
  { cod: "1101", denumire: "Distilarea, rafinarea și mixarea băuturilor alcoolice" },
  { cod: "1102", denumire: "Fabricarea vinurilor din struguri" },
  { cod: "1105", denumire: "Fabricarea berii" },
  { cod: "1107", denumire: "Producția de băuturi răcoritoare nealcoolice; producția de ape minerale și alte ape îmbuteliate" },

  // Industrie non-alimentară
  { cod: "1310", denumire: "Pregătirea fibrelor și filarea fibrelor textile" },
  { cod: "1391", denumire: "Fabricarea de metraje prin tricotare sau croșetare" },
  { cod: "1610", denumire: "Tăierea și rindeluirea lemnului" },
  { cod: "1621", denumire: "Fabricarea de furnire și panouri din lemn" },
  { cod: "1712", denumire: "Fabricarea hârtiei și cartonului" },
  { cod: "1812", denumire: "Alte activități de tipărire n.c.a." },
  { cod: "2016", denumire: "Fabricarea materialelor plastice în forme primare" },
  { cod: "2120", denumire: "Fabricarea preparatelor farmaceutice" },
  { cod: "2229", denumire: "Fabricarea altor produse din material plastic" },
  { cod: "2310", denumire: "Fabricarea sticlei și a articolelor din sticlă" },
  { cod: "2511", denumire: "Fabricarea de construcții metalice și părți componente ale structurilor metalice" },
  { cod: "2822", denumire: "Fabricarea echipamentelor de ridicat și manipulat" },
  { cod: "2910", denumire: "Fabricarea autovehiculelor de transport rutier" },
  { cod: "3092", denumire: "Fabricarea de biciclete și de vehicule pentru invalizi" },
  { cod: "3101", denumire: "Fabricarea de mobilă pentru birouri și magazine" },
  { cod: "3109", denumire: "Fabricarea de mobilă n.c.a." },
  { cod: "3299", denumire: "Fabricarea altor produse manufacturiere n.c.a." },

  // D-E. Energie, apă, deșeuri
  { cod: "3600", denumire: "Captarea, tratarea și distribuția apei" },
  { cod: "3811", denumire: "Colectarea deșeurilor nepericuloase" },
  { cod: "3821", denumire: "Tratarea și eliminarea deșeurilor nepericuloase" },
  { cod: "3900", denumire: "Activități și servicii de decontaminare" },

  // F. Construcții
  { cod: "4110", denumire: "Dezvoltare (promovare) imobiliară" },
  { cod: "4120", denumire: "Lucrări de construcții a clădirilor rezidențiale și nerezidențiale" },
  { cod: "4211", denumire: "Lucrări de construcții a drumurilor și autostrăzilor" },
  { cod: "4321", denumire: "Lucrări de instalații electrice" },
  { cod: "4322", denumire: "Lucrări de instalații sanitare, de încălzire și de aer condiționat" },
  { cod: "4339", denumire: "Alte lucrări de finisare" },

  // G. Comerț cu ridicata și cu amănuntul
  { cod: "4520", denumire: "Întreținerea și repararea autovehiculelor" },
  { cod: "4531", denumire: "Comerț cu ridicata de piese și accesorii pentru autovehicule" },
  { cod: "4611", denumire: "Intermedieri în comerțul cu materii prime agricole, animale vii, materii prime textile" },
  { cod: "4617", denumire: "Intermedieri în comerțul cu produse alimentare, băuturi și tutun" },
  { cod: "4621", denumire: "Comerț cu ridicata al cerealelor, semințelor, furajelor și tutunului neprelucrat" },
  { cod: "4631", denumire: "Comerț cu ridicata al fructelor și legumelor" },
  { cod: "4632", denumire: "Comerț cu ridicata al cărnii și produselor din carne" },
  { cod: "4633", denumire: "Comerț cu ridicata al produselor lactate, ouălor, uleiurilor și grăsimilor comestibile" },
  { cod: "4634", denumire: "Comerț cu ridicata al băuturilor" },
  { cod: "4636", denumire: "Comerț cu ridicata al zahărului, ciocolatei și produselor zaharoase" },
  { cod: "4637", denumire: "Comerț cu ridicata cu cafea, ceai, cacao și condimente" },
  { cod: "4638", denumire: "Comerț cu ridicata specializat al altor alimente, inclusiv pește, crustacee și moluște" },
  { cod: "4639", denumire: "Comerț cu ridicata nespecializat de produse alimentare, băuturi și tutun" },
  { cod: "4641", denumire: "Comerț cu ridicata al produselor textile" },
  { cod: "4645", denumire: "Comerț cu ridicata al produselor cosmetice și de parfumerie" },
  { cod: "4646", denumire: "Comerț cu ridicata al produselor farmaceutice" },
  { cod: "4649", denumire: "Comerț cu ridicata al altor bunuri de uz gospodăresc" },
  { cod: "4665", denumire: "Comerț cu ridicata al mobilei de birou" },
  { cod: "4671", denumire: "Comerț cu ridicata al combustibililor solizi, lichizi și gazoși și al produselor derivate" },
  { cod: "4690", denumire: "Comerț cu ridicata nespecializat" },
  { cod: "4711", denumire: "Comerț cu amănuntul în magazine nespecializate, cu vânzare predominantă de produse alimentare, băuturi și tutun (supermarket)" },
  { cod: "4719", denumire: "Comerț cu amănuntul în magazine nespecializate, cu vânzare predominantă de produse nealimentare" },
  { cod: "4721", denumire: "Comerț cu amănuntul al fructelor și legumelor proaspete, în magazine specializate" },
  { cod: "4722", denumire: "Comerț cu amănuntul al cărnii și al produselor din carne, în magazine specializate" },
  { cod: "4723", denumire: "Comerț cu amănuntul al peștelui, crustaceelor și moluștelor, în magazine specializate" },
  { cod: "4724", denumire: "Comerț cu amănuntul al pâinii, produselor de patiserie și produselor zaharoase, în magazine specializate" },
  { cod: "4725", denumire: "Comerț cu amănuntul al băuturilor, în magazine specializate" },
  { cod: "4726", denumire: "Comerț cu amănuntul al produselor din tutun, în magazine specializate" },
  { cod: "4729", denumire: "Comerț cu amănuntul al altor produse alimentare, în magazine specializate" },
  { cod: "4730", denumire: "Comerț cu amănuntul al carburanților pentru autovehicule în magazine specializate" },
  { cod: "4741", denumire: "Comerț cu amănuntul al calculatoarelor, unităților periferice și software-ului în magazine specializate" },
  { cod: "4751", denumire: "Comerț cu amănuntul al textilelor, în magazine specializate" },
  { cod: "4759", denumire: "Comerț cu amănuntul al mobilei, articolelor de iluminat și al articolelor de uz casnic n.c.a." },
  { cod: "4771", denumire: "Comerț cu amănuntul al îmbrăcămintei, în magazine specializate" },
  { cod: "4772", denumire: "Comerț cu amănuntul al încălțămintei și articolelor din piele, în magazine specializate" },
  { cod: "4773", denumire: "Comerț cu amănuntul al produselor farmaceutice, în magazine specializate (farmacii)" },
  { cod: "4774", denumire: "Comerț cu amănuntul al articolelor medicale și ortopedice, în magazine specializate" },
  { cod: "4775", denumire: "Comerț cu amănuntul al produselor cosmetice și de parfumerie, în magazine specializate" },
  { cod: "4776", denumire: "Comerț cu amănuntul al florilor, plantelor și semințelor" },
  { cod: "4778", denumire: "Comerț cu amănuntul al altor bunuri noi, în magazine specializate" },
  { cod: "4781", denumire: "Comerț cu amănuntul al produselor alimentare, băuturilor și produselor din tutun efectuat prin standuri" },
  { cod: "4791", denumire: "Comerț cu amănuntul prin intermediul caselor de comenzi sau prin Internet" },

  // H. Transport și depozitare
  { cod: "4939", denumire: "Alte transporturi terestre de călători n.c.a." },
  { cod: "4941", denumire: "Transporturi rutiere de mărfuri" },
  { cod: "5210", denumire: "Depozitări" },
  { cod: "5221", denumire: "Activități de servicii anexe pentru transporturi terestre" },

  // I. Hoteluri și restaurante — HoReCa (cea mai importantă categorie pentru DDD)
  { cod: "5510", denumire: "Hoteluri și alte facilități de cazare similare" },
  { cod: "5520", denumire: "Facilități de cazare pentru vacanțe și perioade de scurtă durată" },
  { cod: "5530", denumire: "Parcuri pentru rulote, campinguri și tabere" },
  { cod: "5590", denumire: "Alte servicii de cazare" },
  { cod: "5610", denumire: "Restaurante" },
  { cod: "5621", denumire: "Activități de alimentație (catering) pentru evenimente" },
  { cod: "5629", denumire: "Alte servicii de alimentație n.c.a. (cantine)" },
  { cod: "5630", denumire: "Baruri și alte activități de servire a băuturilor" },

  // J. Informații și comunicații
  { cod: "5811", denumire: "Activități de editare a cărților" },
  { cod: "5813", denumire: "Activități de editare a ziarelor" },
  { cod: "6110", denumire: "Activități de telecomunicații prin rețele cu cablu" },
  { cod: "6201", denumire: "Activități de realizare a soft-ului la comandă" },
  { cod: "6209", denumire: "Alte activități de servicii privind tehnologia informației" },
  { cod: "6311", denumire: "Prelucrarea datelor, administrarea paginilor web și activități conexe" },

  // K. Intermedieri financiare
  { cod: "6419", denumire: "Alte activități de intermedieri monetare (bănci)" },
  { cod: "6420", denumire: "Activități ale holdingurilor" },
  { cod: "6511", denumire: "Activități de asigurări de viață" },
  { cod: "6512", denumire: "Alte activități de asigurări (exceptând asigurările de viață)" },

  // L. Tranzacții imobiliare
  { cod: "6810", denumire: "Cumpărarea și vânzarea de bunuri imobiliare proprii" },
  { cod: "6820", denumire: "Închirierea și subînchirierea bunurilor imobiliare proprii sau închiriate" },
  { cod: "6831", denumire: "Agenții imobiliare" },
  { cod: "6832", denumire: "Administrarea imobilelor pe bază de comision sau contract" },

  // M. Activități profesionale, științifice și tehnice
  { cod: "6910", denumire: "Activități juridice" },
  { cod: "6920", denumire: "Activități de contabilitate și audit financiar; consultanță în domeniul fiscal" },
  { cod: "7010", denumire: "Activități ale direcțiilor (centralelor), birourilor administrative centralizate" },
  { cod: "7022", denumire: "Activități de consultanță pentru afaceri și management" },
  { cod: "7112", denumire: "Activități de inginerie și consultanță tehnică legate de acestea" },
  { cod: "7311", denumire: "Activități ale agențiilor de publicitate" },
  { cod: "7500", denumire: "Activități veterinare" },

  // N. Servicii administrative
  { cod: "7711", denumire: "Activități de închiriere și leasing cu autoturisme și autovehicule rutiere ușoare" },
  { cod: "7810", denumire: "Activități ale agențiilor de plasare a forței de muncă" },
  { cod: "7911", denumire: "Activități ale agențiilor turistice" },
  { cod: "8010", denumire: "Activități de protecție și gardă" },
  { cod: "8121", denumire: "Activități generale de curățenie a clădirilor" },
  { cod: "8122", denumire: "Activități specializate de curățenie" },
  { cod: "8129", denumire: "Alte activități de curățenie" },
  { cod: "8130", denumire: "Activități de întreținere peisagistică" },
  { cod: "8299", denumire: "Alte activități de servicii suport pentru întreprinderi n.c.a." },

  // O. Administrație publică
  { cod: "8411", denumire: "Servicii de administrație publică generală" },
  { cod: "8412", denumire: "Reglementarea activităților organismelor care prestează servicii în domeniul îngrijirii sănătății, învățământului, culturii și al altor activități sociale, exclusiv protecția socială" },

  // P. Învățământ
  { cod: "8510", denumire: "Învățământ preșcolar (grădinițe)" },
  { cod: "8520", denumire: "Învățământ primar (școli)" },
  { cod: "8531", denumire: "Învățământ secundar general" },
  { cod: "8532", denumire: "Învățământ secundar, tehnic sau profesional" },
  { cod: "8541", denumire: "Învățământ superior non-universitar" },
  { cod: "8542", denumire: "Învățământ superior universitar" },
  { cod: "8551", denumire: "Învățământ în domeniul sportiv și recreațional" },
  { cod: "8559", denumire: "Alte forme de învățământ n.c.a." },
  { cod: "8560", denumire: "Activități de servicii suport pentru învățământ" },

  // Q. Sănătate și asistență socială
  { cod: "8610", denumire: "Activități de asistență spitalicească (spitale)" },
  { cod: "8621", denumire: "Activități de asistență medicală generală (cabinete medicale)" },
  { cod: "8622", denumire: "Activități de asistență medicală specializată" },
  { cod: "8623", denumire: "Activități de asistență stomatologică" },
  { cod: "8690", denumire: "Alte activități referitoare la sănătatea umană" },
  { cod: "8710", denumire: "Activități ale centrelor de îngrijire medicală" },
  { cod: "8730", denumire: "Activități ale căminelor de bătrâni și ale căminelor pentru persoane aflate în incapacitate de a se îngriji singure" },
  { cod: "8790", denumire: "Alte activități de asistență socială, cu cazare n.c.a." },
  { cod: "8891", denumire: "Activități de îngrijire zilnică pentru copii" },

  // R. Recreere
  { cod: "9001", denumire: "Activități de interpretare artistică" },
  { cod: "9101", denumire: "Activități ale bibliotecilor și arhivelor" },
  { cod: "9102", denumire: "Activități ale muzeelor" },
  { cod: "9311", denumire: "Activități ale bazelor sportive" },
  { cod: "9313", denumire: "Activități ale centrelor de fitness" },
  { cod: "9321", denumire: "Bâlciuri și parcuri de distracții" },

  // S. Alte activități de servicii
  { cod: "9511", denumire: "Repararea calculatoarelor și a echipamentelor periferice" },
  { cod: "9521", denumire: "Repararea aparatelor electronice de uz casnic" },
  { cod: "9601", denumire: "Spălarea și curățarea (uscată) articolelor textile și a produselor din blană (spălătorii)" },
  { cod: "9602", denumire: "Coafură și alte activități de înfrumusețare (frizerii, coafor)" },
  { cod: "9603", denumire: "Activități de pompe funebre și similare" },
  { cod: "9604", denumire: "Activități de întreținere corporală (saloane spa, fitness)" },
  { cod: "9609", denumire: "Alte activități de servicii n.c.a." },

  // Servicii DDD specifice
  { cod: "8129", denumire: "Alte activități de curățenie n.c.a. (inclusiv dezinfecție, dezinsecție, deratizare — DDD)" },
];

export default CAEN_CODES;
